<template>
    <div class="redirect-container">
        <div v-if="error" class="redirect-error">
            <p>{{ error }}</p>
        </div>
        <div v-else>
            Redirecting you...
        </div>
    </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
    name: 'CampaignTrackRedirect',
    props: ['linkID'],

    data() {
        return {
            error: null
        };
    },

    async created() {
        try {
            let res = await this.resolveTrackingLink({linkID: this.linkID});

            if (res && res.status === 200 && res.data.redirectUrl) {
                window.location.href = res.data.redirectUrl;
                return;
            }

            this.error = 'This link may have expired or is invalid.';
        } catch (err) {
            console.error('CampaignTrackRedirect error:', err);
            this.error = 'This link may have expired or is invalid.';
        }
    },

    methods: {
        ...mapActions('campaignTrackRedirect', ['resolveTrackingLink']),
    },

    computed: {
        ...mapState({
            loading: state => state.alert.loading,
            loaded: state => state.alert.loaded,
            errored: state => state.alert.errored,
        })
    }
};
</script>

<style scoped>
.redirect-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    font-size: 1.1rem;
    color: #64748b;
}
.redirect-error {
    color: #dc3545;
}
</style>
